export default function DownloadFile({blob, fileName}) {
	function downloadFile() {
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = fileName;
		a.click();
		a.remove();
	}
	return (
		<button className={"btn btn-sm btn-secondary"} type={"button"} onClick={downloadFile}>Download file</button>
	)
}